import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import { cn } from "@/utils/utils";
import {
  Popover,
  PopoverContent,
  PopoverTrigger
} from "@/components/ui/popover";
import { ONBOARDING_STAGE_COLORS, OnboardingStageColor } from "../colors";
import ColorSwatch from "./ColorSwatch";

interface Props {
  value: string;
  onChange: (hex: string) => void;
  options?: OnboardingStageColor[];
  triggerClassName?: string;
}

const ColorPickerField: React.FC<Props> = ({
  value,
  onChange,
  options = ONBOARDING_STAGE_COLORS,
  triggerClassName
}) => {
  const [open, setOpen] = useState(false);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-test="onboarding-color-picker-trigger"
          className={cn(
            "flex flex-row items-center justify-between gap-2 h-9 px-2 rounded-md",
            "border border-border-border2 bg-surface-elevation1",
            "hover:bg-surface-hover-soft",
            triggerClassName
          )}
        >
          <ColorSwatch hex={value} size="trigger" />
          <ChevronDown
            className={cn(
              "w-4 h-4 text-secondary transition-transform",
              open && "rotate-180"
            )}
          />
        </button>
      </PopoverTrigger>
      <PopoverContent
        align="end"
        sideOffset={8}
        className="w-auto p-3"
        data-test="onboarding-color-picker-content"
      >
        <div className="grid grid-cols-2 gap-3">
          {options.map((option) => (
            <ColorSwatch
              key={option.id}
              hex={option.hex}
              selected={option.hex === value}
              onClick={() => {
                onChange(option.hex);
                setOpen(false);
              }}
            />
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default ColorPickerField;
